import {SelectedWellTypeInterface} from "../../types/selected-well-type.interface";

export class GetSelectedWell {
  static readonly type = '[BuildModel] Get selected well';

  constructor(public payload: SelectedWellTypeInterface) {
  }
}
